export default "__VITE_ASSET__2c4057dc__"